import { Broker } from '../../../queries/brokerQueries';
import { CardSectionLabel } from './CardSectionLabel';
import { hasBrokerAddress } from '../functions/hasBrokerAddress';

/** "Address:" and the broker's street and city lines; nothing when it has no address. */
export const BrokerAddress = ({ broker }: { broker: Broker }) => {
    const hasCityLine = !!(broker.city && broker.state && broker.zipCode);

    if (!hasBrokerAddress(broker)) {
        return null;
    }

    return (
        <div>
            <CardSectionLabel>Address:</CardSectionLabel>
            {broker.street1 && <div>{broker.street1}</div>}
            {broker.street2 && <div>{broker.street2}</div>}
            {hasCityLine && (
                <div>
                    {broker.city}, {broker.state} {broker.zipCode}
                </div>
            )}
        </div>
    );
};
